define( [
	"./class2type"
], function( class2type ) {
	return class2type.hasOwnProperty;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/hasOwn.js